/* =========================================================
   The STORY Method — behavior
   Vanilla port of the original page logic. Runs on load,
   no framework required. Selectors/IDs/classes unchanged so
   every animation behaves exactly as the original.
   ========================================================= */
(function () {
  function init() {
    var root = document;

    /* ---- Typing manuscript effect (loops) ---- */
    var typeEl = root.getElementById('sm-type');
    if (typeEl) {
      var passages = [
        "She didn't hear him come in. She only felt the warmth of him behind her, close enough that the whole room seemed to lean in and wait\u2026",
        "He didn't touch her. Not yet. He simply began to speak \u2014 low, unhurried \u2014 and she found she'd stopped breathing to listen\u2026",
        "By the time he reached the part she'd been waiting for, she had already turned toward him. She was the one who closed the distance."
      ];
      var pi = 0, ci = 0, deleting = false;
      var cursor = '<span style="display:inline-block;width:2px;height:1em;background:#C94B2C;vertical-align:-0.14em;margin-left:1px;animation:sm-blink 1s step-end infinite;"></span>';
      var tick = function () {
        var full = passages[pi];
        if (!deleting) {
          ci++;
          typeEl.innerHTML = full.slice(0, ci) + cursor;
          if (ci >= full.length) { deleting = true; return setTimeout(tick, 2600); }
          setTimeout(tick, 34 + Math.random() * 34);
        } else {
          ci -= 3;
          if (ci <= 0) { ci = 0; deleting = false; pi = (pi + 1) % passages.length; return setTimeout(tick, 340); }
          typeEl.innerHTML = full.slice(0, ci) + cursor;
          setTimeout(tick, 14);
        }
      };
      tick();
    }

    /* ---- Ember particles ---- */
    var spawnEmbers = function (host, count) {
      if (!host) return;
      host.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var e = root.createElement('span');
        var size = 2 + Math.random() * 3;
        e.style.cssText = 'position:absolute;bottom:-10px;left:' + (Math.random() * 100) + '%;width:' + size + 'px;height:' + size + 'px;border-radius:50%;background:' + (Math.random() > 0.5 ? '#C94B2C' : '#D4A843') + ';opacity:0;filter:blur(0.5px);animation:sm-emberrise ' + (6 + Math.random() * 7) + 's linear ' + (Math.random() * 8) + 's infinite;';
        host.appendChild(e);
      }
    };
    spawnEmbers(root.getElementById('sm-embers'), 26);
    spawnEmbers(root.getElementById('sm-embers2'), 18);

    /* ---- Scroll reveal ---- */
    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    reveals.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(26px)';
      el.style.transition = 'opacity .8s cubic-bezier(.2,.8,.2,1), transform .8s cubic-bezier(.2,.8,.2,1)';
    });
    if ('IntersectionObserver' in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'translateY(0)'; ro.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { ro.observe(el); });
    } else {
      reveals.forEach(function (el) { el.style.opacity = '1'; el.style.transform = 'none'; });
    }

    /* ---- Count-up stats ---- */
    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-count]'));
    var runCount = function (el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      var suffix = el.getAttribute('data-suffix') || '';
      var dur = 1500, start = performance.now();
      var step = function (now) {
        var p = Math.min((now - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = target * eased;
        el.textContent = (decimals ? val.toFixed(decimals) : Math.round(val)) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = (decimals ? target.toFixed(decimals) : Math.round(target)) + suffix;
      };
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var co = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); co.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { co.observe(el); });
    }

    /* ---- Anticipation meter + reading progress + spine dot + nav + sticky ---- */
    var fill = root.getElementById('sm-meter-fill');
    var pct = root.getElementById('sm-meter-pct');
    var meterSection = fill ? fill.closest('section') : null;

    var progress = root.getElementById('sm-progress');
    var nav = root.getElementById('sm-nav');
    var sticky = root.getElementById('sm-sticky');
    var hero = root.getElementById('sm-hero');
    var dot = root.getElementById('sm-dot');
    var spineWrap = dot ? dot.parentElement : null;

    var onScroll = function () {
      var st = window.scrollY;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = docH > 0 ? st / docH : 0;
      if (progress) progress.style.width = (ratio * 100).toFixed(2) + '%';

      if (nav) {
        if (st > 40) {
          nav.style.background = 'rgba(11,10,9,0.94)';
          nav.style.borderBottomColor = 'rgba(255,255,255,0.08)';
          nav.style.backdropFilter = 'blur(10px)';
          nav.style.webkitBackdropFilter = 'blur(10px)';
        } else {
          nav.style.background = 'rgba(11,10,9,0)';
          nav.style.borderBottomColor = 'rgba(255,255,255,0)';
          nav.style.backdropFilter = 'blur(0px)';
          nav.style.webkitBackdropFilter = 'blur(0px)';
        }
      }

      if (dot && spineWrap) {
        var wrapRect = spineWrap.getBoundingClientRect();
        var vh = window.innerHeight;
        var raw = (vh * 0.5 - wrapRect.top);
        var clamped = Math.max(0, Math.min(raw, wrapRect.height));
        dot.style.top = clamped + 'px';
      }

      if (fill && meterSection) {
        var r = meterSection.getBoundingClientRect();
        var vh2 = window.innerHeight;
        var p = (vh2 - r.top) / (vh2 + r.height * 0.4);
        p = Math.max(0, Math.min(1, p));
        fill.style.width = (p * 100).toFixed(1) + '%';
        if (pct) pct.textContent = Math.round(p * 100) + '%';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    /* ---- Affiliate CTA override ---- */

    // Your normal Shopify product page
    const DEFAULT_CTA = "https://www.seduction-lab.com/cart/57311061475715:1";

    // Affiliate links
    const affiliateLinks = {
      themandoctrine: "https://gumroad.com/a/385878115/bldhc?wanted=true",
      the_ceo99: "https://gumroad.com/a/1070745699/bldhc?wanted=true",
      datingintel: "Https://gumroad.com/a/840906339/bldhc?wanted=true",
      // Add more affiliates here
    };

    // Read ?affiliate=john
    const affiliate = new URLSearchParams(window.location.search).get("affiliate");

    // Choose the correct link
    const ctaUrl = affiliateLinks[affiliate] || DEFAULT_CTA;

    // Update every CTA button
    root.querySelectorAll(".sm-cta-lift, .sm-cta-sticky").forEach(function(button) {
      button.href = ctaUrl;
});

    if (sticky && hero && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.style.transform = e.isIntersecting ? 'translateY(120%)' : 'translateY(0)'; });
      }, { threshold: 0 });
      so.observe(hero);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
